import React, { FC, PropsWithChildren, useEffect } from "react";
import Footer from "components/layout/footer";
import Header from "components/layout/header";
import { RootState } from "store/reducers/types";
import { connect } from "react-redux";
import Filters from "components/layout/filters";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Dispatch } from "redux";
import { setFiltersOpen } from "store/actions/filters";

interface StateProps {
  filtersOpen: boolean; 
  recruiterIds?: number[];
};

interface DispatchProps {
	setFiltersOpen: (isOpen: boolean) => void;
};

type OwnProps = RouteComponentProps & {};
type LayoutWithFiltersProps = StateProps & DispatchProps & OwnProps;

const toggleFiltersOpenClass = (toggle: boolean): void => {
  document.body.classList.toggle('filters-open', toggle);
};

const FullLayoutWithFilters: FC<PropsWithChildren<LayoutWithFiltersProps>> = ({ filtersOpen, recruiterIds, history, setFiltersOpen, children }: PropsWithChildren<LayoutWithFiltersProps>) => {
  useEffect(() => {
    if (!recruiterIds) {
      history.replace('/app/overview');
    }
  }, [recruiterIds, history]);

	useEffect(() => {
		toggleFiltersOpenClass(filtersOpen);
  }, [filtersOpen]);
  
  useEffect(() => {
    return () => {
      setFiltersOpen(false);
      toggleFiltersOpenClass(false);
    }
  }, [setFiltersOpen]);

  return (
    <div className={`app app-layout-private app-layout-with-filters ${filtersOpen ? 'filters-open' : ''}`.trim()}>
      <Header />
      <div className="container app-content">
				{children}
			</div>
      <Footer />
			<Filters />
    </div>
  );
};

const mapStateToProps = (state: RootState): StateProps => ({
  filtersOpen: state.filters.isOpen,
  recruiterIds: state.recruiterIds.contents?.recruiterIds
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  setFiltersOpen: (isOpen: boolean) => dispatch(setFiltersOpen(isOpen))
});


export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(FullLayoutWithFilters));